import { ReferenceLoader } from 'legacy/lut/hoc/ReferenceLoader'
import { ReactNode } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'

interface IReferenceWrapper {
  children: ReactNode
}

export const ReferenceWrapper = ({ children }: IReferenceWrapper) => {
  const user = useSelector(selectUser)
  const isAuthorized = Boolean(user.id)

  if (isAuthorized) {
    return <ReferenceLoader>{children}</ReferenceLoader>
  }

  return <>{children}</>
}
